import React from "react"

import {FieldQuickFilterViewProps} from "../../../../render/quick-filter-view"
import {BREAKDOWN_ALL_VALUES} from "../../../../../gd-modules/tasks-view/core/@const"
import ProjectIconUI5 from "../../../../../gd-components/icons/project/project-icon-ui5"
import {ItemIconSize} from "../../../../../gd-components/icons/@const"

export default function FieldProject_QuickFilterView(props: FieldQuickFilterViewProps) {


    const {value} = props

    switch (value) {
        case BREAKDOWN_ALL_VALUES:
            return <div className="name">All projects</div>

        default         :
            const project = gd.session.projects.get(value);
            if (project) {
                return (
                    <React.Fragment>
                        <ProjectIconUI5 className="icon" size={ItemIconSize.SIZE_14} projectId={value} colorize={false}/>
                        <div className="name">{project.name}</div>
                    </React.Fragment>
                )
            } else {
                <div className="ui5-txt-default">{value}</div>
            }
    }


}
